import React from 'react';
import SearchInput from '../../searchinput';
import SearchResults from '../../searchresults';
import translate from '../../../../utils/translate';

export default class HeaderMobileSearchDiscover extends React.Component {
  static propTypes = {
    discover: React.PropTypes.object
  };

  state = {
    openPanel: false
  };

  toggleSearchPanel = () => {
    const newOpenPanel = this.state.openPanel === 'search' ? false : 'search';
    this.setState({
      openPanel: newOpenPanel
    });
  };

  toggleDiscoverPanel = () => {
    const newOpenPanel = this.state.openPanel === 'discover' ? false : 'discover';
    this.setState({
      openPanel: newOpenPanel
    });
  };

  renderPanel = () => {};

  render () {
    const discoverText = (this.state.openPanel === 'discover'
      ? translate('headerModule', 'CLOSE')
      : translate('browseEventsModule', 'BROWSE_MODULE_HEADER'));

    let discoverButtonClass = 'searchdiscover__tab--discover';

    discoverButtonClass += this.state.openPanel === 'discover' ? ' is-active' : '';

    return (
      <div className="searchdiscover">
        <div className="header__panel--mobile">
          <SearchInput {...this.props} />
          <SearchResults {...this.props} isMobile />
        </div>
        <button
          onClick={this.toggleDiscoverPanel}
          className={discoverButtonClass}
          data-component="mobileDiscoveryTab">{discoverText}</button>

        {this.renderPanel()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/mobile/searchdiscover/index.js